import React from "react";
import "./collaborationsSection.css";
import fastighetsmassan from "../../../assets/partners/fastighetmassan.webp";
import vinnova from "../../../assets/partners/vinnova.webp";
import uic from "../../../assets/partners/uic.webp";
import hyperisland from "../../../assets/partners/hyperisland.webp";
import rekomo from "../../../assets/partners/rekomo.webp";
import portally from "../../../assets/partners/portally.webp";
import sizzle from "../../../assets/partners/sizzle.webp";
import welistenin from "../../../assets/partners/welistenin.webp";
import inrego from "../../../assets/partners/inrego.webp";
import viablecities from "../../../assets/partners/viablecities.webp";
import sevena from "../../../assets/partners/7a.webp";
import ebie from "../../../assets/partners/ebie.webp";

export default function CollaborationsSection() {
  return (
    <div className={`collaborations-section`}>
      <h2>Samarbetspartners och finansiärer</h2>
      <div>
        <a
          className={`single-collaborator`}
          href={"https://www.fastighetsmassansthlm.se/advisory-board/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className={`single-collaborator`}
            alt={"Fastighets mässan"}
            src={fastighetsmassan}
            width={175}
            height={100}
          />
        </a>

        <a
          className={`single-collaborator lg`}
          href={
            "https://www.vinnova.se/p/vakansa---identifierar-vakanser-for-hallbara-stader/"
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className={`single-collaborator`}
            alt={"Vinnova"}
            src={vinnova}
            width={175}
            height={100}
          />
        </a>
        <a
          className={`single-collaborator`}
          href={"https://uic.se/bolag/vakansa/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className={`single-collaborator`} alt={"UIC"} src={uic} 
            width={175}
            height={100} />
        </a>

        <a
          className={`single-collaborator lg`}
          href={"https://www.hyperisland.com/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className={`single-collaborator`}
            alt={"Hyper island"}
            src={hyperisland}
            width={175}
            height={100}
          />
        </a>
        <a
          className={`single-collaborator md`}
          href={"https://www.rekomo.se/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className={`single-collaborator`} alt={"Rekomo"} src={rekomo}
            width={175}
            height={100} />
        </a>
        <a
          className={`single-collaborator sm`}
          href={"https://www.portally.com/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className={`single-collaborator`}
            alt={"Portally"}
            src={portally}
            width={175}
            height={100}
          />
        </a>
        <a
          className={`single-collaborator`}
          href={"https://www.sizzle.se/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className={`single-collaborator`} alt={"Sizzle"} src={sizzle}
            width={175}
            height={100} />
        </a>
        <a
          className={`single-collaborator`}
          href={"https://www.welistenin.com/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className={`single-collaborator`}
            alt={"We listen in"}
            src={welistenin}
            width={175}
            height={100}
          />
        </a>
        <a
          className={`single-collaborator sm`}
          href={"https://inrego.se/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className={`single-collaborator`} alt={"Inrego"} src={inrego} 
            width={175}
            height={100} />
        </a>
        <a
          className={`single-collaborator sm`}
          href={"https://viablecities.se/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className={`single-collaborator`}
            alt={"Viable Cities"}
            src={viablecities}
            width={175}
            height={100}
          />
        </a>
        <a
          className={`single-collaborator seven`}
          href={"https://7a.se/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className={`single-collaborator`} alt={"7a"} src={sevena} 
            width={175}
            height={100} />
        </a>
        <a
          className={`single-collaborator`}
          href={"https://ebie.se/"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className={`single-collaborator`} alt={"Ebie"} src={ebie}
            width={175}
            height={100} />
        </a>
      </div>
    </div>
  );
}
